import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import bus from '@/helpers/events/bus';
import i18n from '@/i18n';
import { disable } from '@/services/userSettings';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { createToastContent } from '@/utilities/toast/createToast';
import { resetUserPassword } from '../data/resetUserPassword';
const toast = useToast();
const { t } = i18n.global;
export function useUsersActions() {
    const selectedUser = ref(null);
    const loadingReset = ref(false);
    const errorReset = ref(false);
    const togglingUserId = ref(null);
    async function disableUser(user) {
        const ENABLED = 1;
        const DISABLED = 0;
        const userEnabled = user.enabled === ENABLED ? DISABLED : ENABLED;
        useMixpanelConfig('settings-users_clicked_btn-toggle-status');
        // Set loading state
        togglingUserId.value = user.id;
        try {
            const response = await disable(user.id, userEnabled);
            if (response?.data?.success) {
                bus.$emit('update-users');
                toast.success(t('settings.users.status-changed'), { timeout: 5000 });
            }
            else {
                toast.error(t('settings.users.edit.error'), { timeout: 10000 });
            }
        }
        finally {
            togglingUserId.value = null;
        }
    }
    async function resetPassword() {
        if (!selectedUser.value?.id)
            return;
        loadingReset.value = true;
        try {
            const { success } = await resetUserPassword(selectedUser.value.id);
            if (success) {
                const content = createToastContent(t('settings.users.reset-success.title'), t('settings.users.reset-success.message'));
                toast.success(content, { timeout: 5000, icon: false });
                bus.$emit('closeUserQuestionModal');
            }
        }
        catch {
            errorReset.value = true;
        }
        finally {
            loadingReset.value = false;
        }
    }
    function triggerConfirmModal(user) {
        useMixpanelConfig('settings-users_clicked_btn-reset-password');
        selectedUser.value = user;
        bus.$emit('openUserQuestionModal');
        errorReset.value = false;
    }
    function unlockUserModal(user) {
        useMixpanelConfig('settings-users_clicked_btn-unlock-user');
        bus.$emit('openUserUnlockModal', user);
    }
    return {
        loadingReset,
        errorReset,
        togglingUserId,
        disableUser,
        resetPassword,
        triggerConfirmModal,
        unlockUserModal,
    };
}
